module.exports = __webpack_public_path__ + "img/Pizza Hut.2e9f391e.svg";